import React from "react";

const Input = ({ label, value, onChange, name, type = "text", placeholder }) => {
  return (
    <div className="mb-4">
      {/* Etiket */}
      <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
      {/* Giriş Kutusu */}
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full h-10 px-4 py-2 text-gray-900 bg-white border rounded-md border-gray-300   shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
      />
    </div>
  );
};

export default Input;
